import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { borders } from 'styled-system';
import { strictSpace } from '../../utils';

/* babel-plugin-inline-import '../../assets/block-radio-check.svg' */
var BlockRadioCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNjcxIDU2NnEwIDQwLTI4IDY4bC03MjQgNzI0LTEzNiAxMzZxLTI4IDI4LTY4IDI4dC02OC0yOGwtMTM2LTEzNi0zNjItMzYycS0yOC0yOC0yOC02OHQyOC02OGwxMzYtMTM2cTI4LTI4IDY4LTI4dDY4IDI4bDI5NCAyOTUgNjU2LTY1N3EyOC0yOCA2OC0yOHQ2OCAyOGwxMzYgMTM2cTI4IDI4IDI4IDY4eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
/**
 * Renders a `<ChoiceButton>`.
 */

var ChoiceButton = styled.button.withConfig({
  displayName: "ChoiceButton",
  componentId: "sc-hokkmt-0"
})(["position:relative;display:block;color:", ";background:", ";border-radius:", ";font-size:1.25em;width:100%;max-width:", ";", " ", " &:hover{background:", ";}&:disabled{color:", ";cursor:not-allowed;}&:disabled:hover{background:", ";}", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.textPrimary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.bgActionSecondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.radius8;
}, function (_ref4) {
  var maxWidth = _ref4.maxWidth;
  return maxWidth || '20em';
}, strictSpace, borders, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.bgHoverSecondary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.textDisabled;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.bgHoverSecondary;
}, function (_ref8) {
  var highlight = _ref8.highlight;
  return highlight && css(["background-color:", ";color:", ";&:hover{background:", ";}"], function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.bgCTAPrimary;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.textCTAPrimary;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.bgHoverPrimary;
  });
}, function (_ref12) {
  var selected = _ref12.selected;
  return selected && css(["background-color:", ";color:", ";&:hover{background:", ";}&:after{content:'';position:absolute;right:0.5em;top:50%;width:1em;height:1em;background:url(", ") no-repeat center;background-size:contain;transform:translate(0,-50%);}"], function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.bgCTAPrimary;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.textCTAPrimary;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.bgHoverPrimary;
  }, BlockRadioCheck);
}, function (_ref16) {
  var error = _ref16.error;
  return error && css(["border:1px solid ", ";color:", ";"], function (_ref17) {
    var theme = _ref17.theme;
    return theme.colors.bgNegativeSecondary;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.colors.textNegativePrimary;
  });
});
ChoiceButton.defaultProps = {
  py: 's',
  pl: 's',
  pr: 'm',
  mt: 's'
};
ChoiceButton.propTypes = {
  highlight: PropTypes.bool,
  selected: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool
};
/** @component */

export default ChoiceButton;